import { render, staticRenderFns } from "./EcommInvetoryReport.vue?vue&type=template&id=2b440c29&"
import script from "./EcommInvetoryReport.vue?vue&type=script&lang=js&"
export * from "./EcommInvetoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports